const getDefaultPreconfiguration = preconfigurations => {
  return (
    preconfigurations.find(preconfiguration => preconfiguration.default) ||
    preconfigurations[0]
  );
};

module.exports = { getDefaultPreconfiguration };
